import styled from '@emotion/styled';

import Accordion from '@mui/material/Accordion';

export default styled(Accordion)`
  background-color: #FAFAFA;
  box-shadow: none;

  .MuiAccordionSummary-content {
    display: flex;
    justify-content: space-between;
  }

  .revert-button {
    color: #97989E;
    padding: 5px 10px;
    border-radius: 10px !important;
    margin-right: 4px;
    border: none;
    background-color: #F0F0F0;
    text-transform: none;
  }

  .apply-button {
    background-color: #05B2DC;
    color: #FFF;
    border-radius: 10px;
    font-size: 14px;
    text-transform: none;

    &.Mui-selected,:active,:hover {
      background-color: #05B2DC;
      opacity: 0.7;
    }
  }
`;
